const t=["_v","http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata","token_type"],e="A token is required";export{t as GELADA_JWT_KEYS,e as TOKEN_IS_REQUIRED};
//# sourceMappingURL=useJwtDecoder.constants.js.map
